module.exports = __webpack_public_path__ + "img/logo人民公开课.0dd82ebe.png";